import { Routes } from '@angular/router';
import {
  DEPOSIT_CRYPTO_METHODS,
  DEPOSIT_SKINS_METHODS,
  DEPOSIT_SURVEY_METHODS,
} from '@features/deposit/constants/deposit';
import { userGuard } from '@core/guards/user.guard';
import { adminGuard } from '@features/admin/guards/admin.guard';
import { adminEnvironmentGuard } from '@features/admin/guards/admin-environment.guard';
import { adminWithdrawGuard } from '@features/admin/guards/admin-witrhdraw.guard';

// Import components directly instead of lazy loading
import { CasesListComponent } from './features/cases/cases-list/cases-list.component';
import { CasesOpenComponent } from './features/cases/cases-open/cases-open.component';
import { CbListComponent } from './features/case-battles/cb-list/cb-list.component';
// import { CbCreateComponent } from './features/case-battles/cb-create/cb-create.component';
import { CbBattleComponent } from './features/case-battles/cb-battle/cb-battle.component';
import { KingComponent } from './old/king/king/king.component';
import { CoinflipComponent } from './old/coinflip/coinflip.component';
// import { CoinflipHistoryComponent } from './old/coinflip/coinflip-history/coinflip-history.component';
import { PlinkoComponent } from './old/plinko/plinko.component';
import { JackpotHighrollerComponent } from './old/jackpot/jackpot-highroller/jackpot-highroller.component';
import { UpgraderComponent } from './old/upgrader/upgrader/upgrader.component';
import { UpgraderNewComponent } from './features/upgrader-new/upgrader-new.component';
import { KingNewComponent } from './features/king-new/king-new.component';
import { WheelComponent } from './old/wheel/wheel/wheel.component';
import { TowersComponent } from './old/towers/towers.component';
import { MinesComponent } from './old/mines/mines.component';
import { HomeComponent } from './features/home/home.component';
import { AuthComponent } from './features/auth/auth.component';
// import { FaqComponent } from './features/faq/faq.component';
// import { TosComponent } from './features/tos/tos.component';
// import { LeaderboardComponent } from './features/leaderboard/leaderboard.component';
// import { RewardsComponent } from './features/rewards/rewards.component';
import { RewardsDailyUnboxingComponent } from './features/rewards/rewards-daily-unboxing/rewards-daily-unboxing.component';
import { RewardsRewardUnboxingComponent } from './features/rewards/rewards-reward-unboxing/rewards-reward-unboxing.component';
// import { WithdrawComponent } from './features/withdraw/withdraw.component';
// import { ProvablyFairComponent } from './features/provably-fair/provably-fair.component';
// import { DepositComponent } from './features/deposit/deposit.component';
// import { DepositMethodsListComponent } from './features/deposit/deposit-methods-list/deposit-methods-list.component';
// import { DepositCryptoComponent } from './features/deposit/deposit-crypto/deposit-crypto.component';
// import { AffiliatesUnboxingComponent } from '@features/affiliates/affiliates-unboxing/affiliates-unboxing.component';
// import { AffiliatesUnboxingComponent } from '@features/affiliates/affiliates-unboxing/affiliates-unboxing.component';
// import { SupportComponent } from './features/support/support.component';
// import { GiveawaysComponent } from './features/giveaways/giveaways.component';
// import { AffiliatesNewComponent } from '@features/affiliates/affiliates-new/affiliates-new.component';

const games: Routes = [
  {
    path: 'cases',
    component: CasesListComponent,
  },
  {
    path: 'cases/:link',
    component: CasesOpenComponent,
  },
  {
    path: 'battles',
    component: CbListComponent,
  },
  {
    path: 'battles/create',
    // component: CbCreateComponent,
    loadComponent: () =>
      import('./features/case-battles/cb-create/cb-create.component').then(
        (m) => m.CbCreateComponent
      ),
  },
  {
    path: 'battles/:gameuid',
    component: CbBattleComponent,
  },
  {
    path: 'king',
    component: KingComponent,
  },
  {
    path: 'king-new',
    component: KingNewComponent,
  },
  {
    path: 'coinflip',
    component: CoinflipComponent,
  },
  {
    path: 'coinflip/history',
    loadComponent: () =>
      import('./old/coinflip/coinflip-history/coinflip-history.component').then(
        (m) => m.CoinflipHistoryComponent
      ),
  },
  {
    path: 'plinko',
    component: PlinkoComponent,
  },
  {
    path: 'jackpot',
    component: JackpotHighrollerComponent,
  },
  {
    path: 'upgrader',
    component: UpgraderComponent,
  },
  {
    path: 'upgrader-new',
    component: UpgraderNewComponent,
  },
  {
    path: 'wheel',
    component: WheelComponent,
  },
  {
    path: 'towers',
    component: TowersComponent,
  },
  {
    path: 'mines',
    component: MinesComponent,
  },
];

const admin: Routes = [
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin/admin.component').then(
        (mod) => mod.AdminComponent
      ),
    canActivate: [adminGuard],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      {
        path: 'new_dashboard',
        loadComponent: () =>
          import(
            './features/admin/admin-new-dashboard/admin-new-dashboard.component'
          ).then((mod) => mod.AdminNewDashboardComponent),
      },
      {
        path: 'old_dashboard',
        loadComponent: () =>
          import(
            './features/admin/admin-dashboard/admin-dashboard.component'
          ).then((mod) => mod.AdminDashboardComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/admin/admin-users/admin-users.component').then(
            (mod) => mod.AdminUsersComponent
          ),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./features/admin/admin-support/admin-support.component').then(
            (mod) => mod.AdminSupportComponent
          ),
      },
      {
        path: 'items',
        loadComponent: () =>
          import('./features/admin/admin-items/admin-items.component').then(
            (mod) => mod.AdminItemsComponent
          ),
      },
      {
        path: 'unpriced',
        loadComponent: () =>
          import(
            './features/admin/admin-unpriced/admin-unpriced.component'
          ).then((mod) => mod.AdminUnpricedComponent),
      },
      {
        path: 'filter',
        loadComponent: () =>
          import('./features/admin/admin-filter/admin-filter.component').then(
            (mod) => mod.AdminFilterComponent
          ),
      },
      {
        path: 'limits',
        loadComponent: () =>
          import('./features/admin/admin-limits/admin-limits.component').then(
            (mod) => mod.AdminLimitsComponent
          ),
      },
      {
        path: 'games',
        loadComponent: () =>
          import('./features/admin/admin-games/admin-games.component').then(
            (mod) => mod.AdminGamesComponent
          ),
      },
      {
        path: 'trades',
        loadComponent: () =>
          import('./features/admin/admin-trades/admin-trades.component').then(
            (mod) => mod.AdminTradesComponent
          ),
      },
      {
        path: 'bots',
        loadComponent: () =>
          import('./features/admin/admin-bots/admin-bots.component').then(
            (mod) => mod.AdminBotsComponent
          ),
      },
      {
        path: 'case-creator',
        loadComponent: () =>
          import(
            './features/admin/admin-case-creator/admin-case-creator.component'
          ).then((mod) => mod.AdminCaseCreatorComponent),
      },
      {
        path: 'case-creator/case/:link',
        loadComponent: () =>
          import(
            './features/admin/admin-case-creator/admin-case-edit/admin-case-edit.component'
          ).then((mod) => mod.AdminCaseEditComponent),
      },
      {
        path: 'case-creator/new',
        loadComponent: () =>
          import(
            './features/admin/admin-case-creator/admin-case-edit/admin-case-edit.component'
          ).then((mod) => mod.AdminCaseEditComponent),
      },
      {
        path: 'withdraw',
        loadComponent: () =>
          import(
            './features/admin/admin-withdraw/admin-withdraw.component'
          ).then((mod) => mod.AdminWithdrawComponent),
        canActivate: [adminWithdrawGuard],
      },
      {
        path: 'environment',
        loadComponent: () =>
          import(
            './features/admin/admin-environment/admin-environment.component'
          ).then((mod) => mod.AdminEnvironmentComponent),
        canActivate: [adminEnvironmentGuard],
      },
      {
        path: 'new-pricing',
        loadComponent: () =>
          import(
            './features/admin/admin-new-pricing/admin-new-pricing.component'
          ).then((mod) => mod.AdminNewPricingComponent),
      },
    ],
  },
];

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
  // {
  //   path: 'faq',
  //   component: FaqComponent,
  // },
  // {
  //   path: 'tos',
  //   component: TosComponent,
  // },
  // {
  //   path: 'leaderboard',
  //   component: LeaderboardComponent,
  // },
  // {
  //   path: 'rewards',
  //   component: RewardsComponent,
  // },
  {
    path: 'leaderboard',
    loadComponent: () =>
      import('./features/leaderboard/leaderboard.component').then(
        (m) => m.LeaderboardComponent
      ),
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./features/faq/faq.component').then((m) => m.FaqComponent),
  },
  {
    path: 'tos',
    loadComponent: () =>
      import('./features/tos/tos.component').then((m) => m.TosComponent),
  },
  {
    path: 'rewards',
    loadComponent: () =>
      import('./features/rewards/rewards.component').then(
        (m) => m.RewardsComponent
      ),
  },
  {
    path: 'rewards/daily/:link',
    component: RewardsDailyUnboxingComponent,
    // loadComponent: () =>
    // import(
    // './features/rewards/rewards-reward-unboxing/rewards-reward-unboxing.component'
    // ).then((m) => m.RewardsRewardUnboxingComponent),
  },
  {
    path: 'rewards/reward/:link',
    component: RewardsRewardUnboxingComponent,
    // loadComponent: () =>
    //   import(
    //     './features/rewards/rewards-daily-unboxing/rewards-daily-unboxing.component'
    //   ).then((m) => m.RewardsDailyUnboxingComponent),
  },
  {
    path: 'withdraw',
    // component: WithdrawComponent,
    loadComponent: () =>
      import('./features/withdraw/withdraw.component').then(
        (m) => m.WithdrawComponent
      ),
  },
  {
    path: 'provably-fair',
    // component: ProvablyFairComponent,
    loadComponent: () =>
      import('./features/provably-fair/provably-fair.component').then(
        (m) => m.ProvablyFairComponent
      ),
  },
  {
    path: 'provably-fair/:type',
    // component: ProvablyFairComponent,
    loadComponent: () =>
      import('./features/provably-fair/provably-fair.component').then(
        (m) => m.ProvablyFairComponent
      ),
  },
  {
    path: 'provably-fair/:type/:id',
    // component: ProvablyFairComponent,
    loadComponent: () =>
      import('./features/provably-fair/provably-fair.component').then(
        (m) => m.ProvablyFairComponent
      ),
  },
  {
    path: 'provably-fair/:type/:id/:roundid',
    // component: ProvablyFairComponent,
    loadComponent: () =>
      import('./features/provably-fair/provably-fair.component').then(
        (m) => m.ProvablyFairComponent
      ),
  },
  {
    path: 'deposit',
    canActivate: [userGuard],
    // component: DepositComponent,
    loadComponent: () =>
      import('./features/deposit/deposit.component').then(
        (m) => m.DepositComponent
      ),
    children: [
      {
        path: '',
        // component: DepositMethodsListComponent,
        loadComponent: () =>
          import(
            './features/deposit/deposit-methods-list/deposit-methods-list.component'
          ).then((m) => m.DepositMethodsListComponent),
      },
      ...DEPOSIT_CRYPTO_METHODS.methods.map((method) => {
        return {
          path: method.route,
          // component: DepositCryptoComponent,
          loadComponent: () =>
            import(
              './features/deposit/deposit-crypto/deposit-crypto.component'
            ).then((m) => m.DepositCryptoComponent),
        };
      }),
      ...DEPOSIT_SURVEY_METHODS.methods.map((method) => {
        return {
          path: method.route,
          // component: DepositMethodsListComponent,
          loadComponent: () =>
            import(
              './features/deposit/deposit-methods-list/deposit-methods-list.component'
            ).then((m) => m.DepositMethodsListComponent),
        };
      }),
      ...DEPOSIT_SKINS_METHODS.methods.map((method) => {
        return {
          path: method.route,
          // component: DepositMethodsListComponent,
          loadComponent: () =>
            import(
              './features/deposit/deposit-methods-list/deposit-methods-list.component'
            ).then((m) => m.DepositMethodsListComponent),
        };
      }),
    ],
  },
  {
    path: 'support',
    canActivate: [userGuard],
    loadComponent: () =>
      import('./features/support/support.component').then(
        (m) => m.SupportComponent
      ),
  },
  {
    path: 'raffles',
    loadComponent: () =>
      import('./features/giveaways/giveaways.component').then(
        (m) => m.GiveawaysComponent
      ),
  },
  {
    path: 'affiliates',
    loadComponent: () =>
      import(
        '@features/affiliates/affiliates-new/affiliates-new.component'
      ).then((m) => m.AffiliatesNewComponent),
  },
  {
    path: 'affiliates/cases/:link',
    // component: AffiliatesUnboxingComponent,
    loadComponent: () =>
      import(
        '@features/affiliates/affiliates-unboxing/affiliates-unboxing.component'
      ).then((m) => m.AffiliatesUnboxingComponent),
  },
  {
    path: 'r/:affCode',
    loadComponent: () =>
      import(
        '@features/affiliates/affiliates-new/affiliates-new.component'
      ).then((m) => m.AffiliatesNewComponent),
  },
  {
    path: 'p/:promoCode',
    loadComponent: () =>
      import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  ...games,
  ...admin,
  {
    path: '**',
    redirectTo: 'jackpot',
  },
];
